import React from 'react';

export default () => (
  <section className="text-center space--xxs">
    <div className="container">
      <h2>Design your mock</h2>
    </div>
  </section>
);
